import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSensorPlacementForScenarios } from "../../api/sensorPlacementApi";
import { useLazyKeyedResource } from "../../hooks/useLazyKeyedResource";
import { setWindAlarmSensorsIsLoading } from "../../redux/shadingSystem";
import { reduxLocalStorage } from "../utility/storage";
import { SensorPlacementZone } from "./SensorPlacement";

const WindAlarmSensors = () => {
  const projectId = reduxLocalStorage.getItem("project_id");
  const dispatch = useDispatch();

  const shadingControlScenarios =
    useSelector((state) => state.sceneVar.shadingControlScenarios) ?? [];
  const windAlarmByScenario = useSelector(
    (state) => state.shadingSystem.windAlarmSensors,
  );

  const activeScenarios = useMemo(
    () =>
      shadingControlScenarios.filter(
        (scenario) => windAlarmByScenario[scenario],
      ),
    [shadingControlScenarios, windAlarmByScenario],
  );

  const fetcher = useCallback(
    (scenarios) => fetchSensorPlacementForScenarios(projectId, scenarios),
    [projectId],
  );

  const onLoadingChange = useCallback(
    (loading) => dispatch(setWindAlarmSensorsIsLoading(loading)),
    [dispatch],
  );

  const { dataByKey } = useLazyKeyedResource({
    keys: activeScenarios,
    fetcher,
    enabled: Boolean(projectId) && activeScenarios.length > 0,
    onLoadingChange,
  });

  return (
    <>
      {activeScenarios.map((scenario) => {
        const data = dataByKey[scenario];
        if (!data?.length) return null;
        return (
          <SensorPlacementZone
            key={scenario}
            id={`wind-alarm-${scenario}`}
            data={data}
            visible
            colorMode="uniform"
            uniformColor="#FF7A00"
            radius={0.65}
            highlightRadius={1.25}
          />
        );
      })}
    </>
  );
};

export default WindAlarmSensors;
